import React from 'react'
import ReactEcharts from 'echarts-for-react'
import { reqGWASechartData } from '../../../api'

class GWASEchart extends React.Component { 
    state = {
        species: '',
        chr_list: [],
        chr_length: [],
        chr_color: [],
        echartData: [],
        echart_sub_title: '',
        echart_gwas_mark_area_xAxis0: '',
        echart_gwas_mark_area_xAxis1: '',
        showLoading: true
    }
    
    // 用户点击echarts柱状图，更新echarts图指标柱的位置，并更新父级组件默认区间的值，以便更新locuszoom图
    onChartClick = (params) => {
        let query_region = params.data[0]
        let query_chr = query_region.substr(0, query_region.indexOf(':'))
        let query_loc_start = query_region.substr(query_region.indexOf(':')+1, (query_region.indexOf('-') - query_region.indexOf(':') -1))
        let query_loc_end = query_region.substr(query_region.indexOf('-')+1)

        // 更新echarts图指标柱的位置
        this.setState({
            echart_gwas_mark_area_xAxis0: query_region,
            echart_gwas_mark_area_xAxis1: query_region,
        })

        // 更新父级组件默认区间的值
        this.props.stateHandler({ 
            query_chr: query_chr,
            query_loc_start: query_loc_start,
            query_loc_end: query_loc_end, 
        })
        
    }
    
    // echarts 图默认配置参数
    getEchartOption = () => {      
        let option = {
            grid: {

            },
            title: {
                text: `Navigational Manhattan Plot ${this.state.echart_sub_title}`
            },
            dataZoom: [{
                type: 'inside'
            }, {
                type: 'slider'
            }],
            tooltip: {
                trigger: 'axis',
                padding: 10,
                backgroundColor: '#222',
                borderColor: '#777',
                formatter: function(datas)
                {
                    let res = 'Region: ' + datas[0].data[0] + '<br/>'
                    res += '-log10 p-value: ' + datas[0].data[1] + '<br/>'
                    return res
                }
            },
            toolbox: {
                feature: {
                    dataZoom: {
                        yAxisIndex: false,
                        title: {
                            zoom: 'region zoom',
                            back: 'restore zoom'
                        }
                    },
                    saveAsImage: {
                        pixelRatio: 2,
                        title: 'Save as PNG'
                    }
                },
                right: 40
            },
            xAxis: {
                type: 'category',
                name: 'BIN(Mb)',
                nameGap: 16,
                nameTextStyle: {
                    fontSize: 10
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    formatter: function (value, index){
                        if (!value) {
                            return
                        }
                        value = value.replace(':', '-')
                        value = value.split('-')
                        let _start = parseInt(value[1])/1e6
                        let _end = parseInt(value[2])/1e6
                        
                        return value[0]+':'+_start+'-'+_end
                    }
                },
            },
            yAxis: {
                type: 'value',
                name: '-log10 p-value',
                nameLocation: 'end',
                splitLine: {
                    //show: false
                }
            },
            visualMap: [
                {
                    show:false,
                    dimension: 2,
                    top:30,
                    right:40,
                    orient:'horizontal',
                    itemWidth: 16,
                    itemHeight: 10,
                    itemGap: 4,
                    categories: this.state.chr_list,
                    color: this.state.chr_color
                },
            ],
            series: [{
                name: 'GWAS-Bin',
                type: 'bar',
                data: this.state.echartData,
                barCategoryGap: '0.5%',
                markLine: {
                    symbol:'none',
                    silent: true,
                    data: [{
                        yAxis: 7.126089
                    }],
                    lineStyle: {
                        color: '#000'
                    },
                    label: {
                        formatter: "1/N: {c}"
                    }
                },
                markArea: {
                    itemStyle:{
                        color:"#BABABA",
                        borderColor: "#BABABA",
                        borderWidth: 2
                    },
                    data: [[{
                        xAxis: this.state.echart_gwas_mark_area_xAxis0
                    }, {
                        xAxis: this.state.echart_gwas_mark_area_xAxis1
                    }]]
                },
            }]
        }

        return option
    }
    
    async componentDidUpdate(preProps, preState) {
        if (this.props.echart_config !== preProps.echart_config) {
            const { species, query_trait, query_chr, query_loc_start, query_loc_end, chr_list, chr_length, chr_color } = this.props.echart_config

            // 根据父级组件传递的species, trait等参数，获取对应的echarts图数据
            let echart_sub_title = ` ( Trait: ${query_trait} )`
            let query_region = `${query_chr}:${query_loc_start}-${query_loc_end}`

            const result = await reqGWASechartData(species, query_trait)
            let echartData = []
            if (result.code === 0) {
                echartData = result.data
            }
            

            this.setState({ 
                species: species,
                chr_list: chr_list,
                chr_length: chr_length,
                chr_color: chr_color,
                echartData: echartData,
                echart_sub_title: echart_sub_title, 
                echart_gwas_mark_area_xAxis0: query_region,
                echart_gwas_mark_area_xAxis1: query_region,
                showLoading: false
            })
        }
    }

    render() {
        // echarts 事件函数
        let onEvents = {
            "click": this.onChartClick
        }

        return (
            <div className="gwas-echarts">
                <ReactEcharts showLoading={this.state.showLoading} option={ this.getEchartOption() } onEvents={onEvents} />
            </div>
        )
    }
}

export default GWASEchart